export default {
  title: 'Trova qualcosa che ami!',
  description: 'I tuoi ordini saranno elencati qui.',
  buttons: {
    order_now: 'Ordina ora',
  },
};
